<dx-load-panel [visible]="isLoading"
               [position]="{ my: 'center', at: 'center', of: chart }"
></dx-load-panel>
<div #chart id="openposchart_{{chartId}}" style="height: 100%" [ngClass]="{'ets-hidden': !isActive}"></div>